import { RadioTowerIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Radio = /* @__PURE__ */ createIcon(RadioTowerIcon, 'Radio');
